import { components } from "./components/index";
import { events } from "./events/index";


const HierarchySection = {
  components,
  events
};

export { HierarchySection };